import AbsComponent from "../../common/AbsComponent";
import Templ from './MainCharChangeTempl';

/**
 * MainCharChange class
 * 대표캐릭터 설정
 * @category lineage2common
 */
class MainCharChange extends AbsComponent {
    constructor(_store = {}, _el = '') {
        super(_store, _el);
        window.characterChange = this.characterChange.bind(this);
    }

    characterChange() {
        if (this.store.getData('config').isLogin) {
            this.store.getData('CharacterList', {
                grouping: 'server'
            }, this.render.bind(this));
        }
    }

    render(_jsonData = {}) {
        $(this.el).html(Templ.getTempl(_jsonData.data));
        this.addEvents();
    }

    addEvents() {
        $(this.el + ' > li').on('click', (e) => {
            $(this.el + ' > li').removeClass('on');
            $(this.el + ' > li .l2-character-list').hide();
            $(e.currentTarget).addClass('on').find('.l2-character-list').show();
        });

        $(this.el + ' ul.l2-character-list li').on('click', (e) => {
            let data = $(e.currentTarget).data();
            this.store.changeBossChar(data.serverid, data.characterid, (e) => window.location.reload());
            return false;
        });
    }

} // end of class
export default MainCharChange;